import { getApplianceId } from "@/stores/v2/userSessionStore";
import * as clsApi from "@/js/api/classroomApi";
import { errorAdapter } from "@/js/api/util";

export async function addTeacherToClassroom(teacherQoriaUserId: string, classroomStableIdV1: string): Promise<void> {
	await errorAdapter(
		clsApi.Post2<undefined, undefined>(
			`v1/appliances/${getApplianceId()}/classrooms/${classroomStableIdV1}/teachers/${teacherQoriaUserId}`,
			undefined
		)
	);
}

export async function removeTeacherFromClassroom(teacherQoriaUserId: string, classroomStableIdV1: string): Promise<void> {
	await errorAdapter(clsApi.DeleteV2(`v1/appliances/${getApplianceId()}/classrooms/${classroomStableIdV1}/teachers/${teacherQoriaUserId}`));
}
